import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ToastProvider } from "./components/Toast.tsx";
import { guardUnsentChanges, persistCache, restoreCache } from "./lib/offline.ts";
import { queryClient } from "./lib/query.ts";
import { router } from "./router.tsx";
import "@fontsource-variable/inter";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/app.css";
import "./styles/print.css";

// Lokalt först: läs in sparade listor innan första ritningen, spara löpande och varna för ändringar som inte hunnit skickas.
await restoreCache(queryClient);
persistCache(queryClient);
guardUnsentChanges(queryClient);

// Service workern gör att appen går att öppna utan nät. Bara i produktionsbygget, där filerna har fasta namn.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
